import { render, staticRenderFns } from "./AcheteurTypeLabel.vue?vue&type=template&id=18c291ba&scoped=true&"
import script from "./AcheteurTypeLabel.vue?vue&type=script&lang=ts&"
export * from "./AcheteurTypeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AcheteurTypeLabel.vue?vue&type=style&index=0&id=18c291ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c291ba",
  null
  
)

export default component.exports